import { GoogleIcon } from '@sketchnote/icons';
import { LoaderXs } from '@sketchnote/shared-components';
import { googleClientId } from 'config';
import React, { useEffect, useState } from 'react';
import GoogleLogin from 'react-google-login';
import { useDashboardStore } from 'src/features/dashboard/store/useDashboardStore';

export const GooglePage = ({ onClose }: { onClose: () => void }) => {
  const [isLoading, setLoader] = useState<boolean>(true);
  const calendars = useDashboardStore((s) => s.calendars);
  const { actions } = useDashboardStore((state) => state);

  const onGoogleLoginSuccess = async (response) => {
    actions.authGoogleCalendars(response.code);
  };

  useEffect(() => {
    actions.fetchGoogleCalendars(() => {
      setLoader(false);
    });
  }, []);

  const onRemove = async (id: string) => {
    setLoader(true);
    actions.removeGoogleCalendars(id, () => {
      setLoader(false);
    });
  };

  return (
    <div className="overflow-y-auto px-48" style={{ height: '59rem' }}>
      <section className="py-48 pb-28">
        <div className="flex">
          <GoogleIcon wrapperClass="pr-16" size={46} />
          <div>
            <div className="mb-10">
              <div className="font-medium">Google</div>
              <div className="text-sm">Productivity</div>
            </div>
          </div>
        </div>
      </section>
      <section>
        <div className="font-medium text-gray-600 mb-10">Connected Account</div>
        <div className="pb-48">
          {calendars.length === 0 && isLoading && (
            <span className="flex border rounded-md py-12 px-20 animate-pulse bg-gray-300">
              &nbsp;
            </span>
          )}
          {calendars.length === 0 && !isLoading && (
            <div>
              <GoogleLogin
                clientId={googleClientId}
                accessType="offline"
                prompt="consent"
                responseType="code"
                scope="https://www.googleapis.com/auth/calendar.events.readonly https://www.googleapis.com/auth/tasks.readonly"
                onSuccess={onGoogleLoginSuccess}
              />
            </div>
          )}
          {calendars.map((calendar) => (
            <div className="flex justify-between items-center border-b py-12" key={calendar._id}>
              <span className="text-sm text-gray-600">{calendar.email}</span>
              {isLoading ? (
                <LoaderXs className="text-xs mb-4 mr-20" />
              ) : (
                <button
                  className="border-red-700 text-red-700 border rounded-sm px-12 py-8 text-xs"
                  onClick={() => onRemove(calendar._id)}
                >
                  Remove
                </button>
              )}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};
